const players = {
  reviewPlayer: null,
};

export default players;
